<template>
  <li :class="suggestionCssClasses">
    <div :class="`${cssPrefix}-search-result`">
      <a class="image-link link-analytics" :href="searchResult.permalink">
        <img
          :src="searchResult.imagePath"
          :height="imageSize"
          :width="imageSize"
          :alt="searchResult.name"
          class="search-result-image"
        />
      </a>
      <div :class="`${cssPrefix}-result-info`">
        <a :class="`link-analytics ${cssPrefix}-link`" :href="searchResult.permalink">
          <div
            :class="`${cssPrefix}-name ${searchResult.pageType}`"
            v-html="searchResult.highlightedName"
          />
        </a>
        <slot />

        <div v-if="priceRange" :class="`${cssPrefix}-price`">
          {{ priceRange }}
        </div>
        <div v-if="searchResult.rating" :class="`${cssPrefix}-rating`">
          <div class="star-container small-stars">
            <span :class="starRatingCssClasses" />
            <span :class="starRemainderCssClasses" />
          </div>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
  export default {
    props: {
      searchResult: { type: Object, required: true },
      imageSize: { type: String, required: true },
      hasCursor: { type: Boolean, required: true },
      cssPrefix: { type: String, required: true }
    },
    computed: {
      suggestionCssClasses() {
        const constantClasses = `${this.cssPrefix}-search-suggestion`;
        return this.hasCursor ? `${constantClasses} has-cursor` : constantClasses;
      },
      priceRange() {
        if (!this.searchResult.minPrice && !this.searchResult.maxPrice) {
          return false;
        } if (this.searchResult.minPrice === this.searchResult.maxPrice) {
          return `$${this.searchResult.minPrice}`;
        }
        return `$${this.searchResult.minPrice} - $${this.searchResult.maxPrice}`;
      },
      starRating() {
        const rating = Number(this.searchResult.rating);
        return rating === 0 ? false : Math.round(rating)
      },
      starRatingCssClasses() {
        return `star-rating star-rating-${this.starRating}`;
      },
      starRemainderCssClasses() {
        return `remainder-stars remainder-of-${this.starRating}`;
      }
    }
  };
</script>
